module.exports = __webpack_public_path__ + "static/media/promo-image-loyalty.dfff1038.png";